// @ts-strict-ignore
import { TemplateStateHandler } from '@wikia/ad-engine';
import { Injectable } from '@wikia/dependency-injection';
import { PlayerRegistry } from '../../helpers/player-registry';

// Register player registry to utilize its video player resizing logic for the livestream embed
@Injectable({ autobind: false })
export class BflaVideoBootstrapHandler implements TemplateStateHandler {
	constructor(private playerRegistry: PlayerRegistry) {}

	async onEnter(): Promise<void> {
		this.playerRegistry.register();
	}

	async onDestroy(): Promise<void> {
		this.playerRegistry.discard();
	}
}
